import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BrazeService} from '../../networking/services/braze/braze.service';
import { LocalStorageManager } from '../local-storage/local-storage.manager';
import { ContentCardFormatted, ContentCardsResponse } from '../../networking/models/braze/content-cards';

declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class BrazeManager {
  constructor(
    private brazeService: BrazeService,
    private localStorageManager: LocalStorageManager,
  ) {}

  lastItemViewed(id): Observable<any> {
    return this.brazeService.get({
      "external_ids": [`${id}`],
      "fields_to_export": ["custom_attributes", "last item viewed"]
    });
  }

  getBirthday(id: string): Observable<any> {
    return this.brazeService.getUserData({
      deviceId: id,
      fieldsToExport: ['email', 'dob'],
    });
  }

  getGender(id): Observable<any> {
    return this.brazeService.get({
      "external_ids": [`${id}`],
      "fields_to_export": ["gender"]
    });
  }

  getAllData(id): Observable<any> {
    return this.brazeService.get({
      "external_ids": [`${id}`],
      "fields_to_export": ["dob", "custom_attributes"]
    });
  }

  getContentCardsApi(userId: string): Observable<ContentCardFormatted[]> {
    window?.braze?.changeUser(userId);

    const deviceIdUnknown = 'unknown';
    const deviceIdToAnalize = window?.braze?.getDeviceId();
    const deviceId = !deviceIdToAnalize || deviceIdToAnalize === true
      ? deviceIdUnknown
      : deviceIdToAnalize;

    const data = {
      device_id: deviceId,
      user_id: userId,
    };

    return this.brazeService.getContentCardsApi(data)
      .pipe(map((response: ContentCardsResponse) => {
        let cards: ContentCardFormatted[] = [];
        cards = response?.cards?.map((card) => {
          return {
            extras: card.e,
            viewed: card.v,
            imageUrl: card.i,
            created: `${card.ca}000`,
            title: card.tt,
            description: card.ds,
            url: card.u,
            type: card.tp,
            expiresAt: (card.ea || 0) * 1000,
            linkText: card.dm
          };
        });
        return cards;
      }));
  }

}
